
(function() {
  var result = { translations: { "sv": { "i18n": { "duration": { "seconds": "{{ seconds }} sek", "minutes": "{{ minutes }} min", "hours": "{{ hours }} tim", "hoursAndMinutes": "{{ hours }} tim {{ minutes }} min", "days": "{{ days }} dagar", "shortForm": { "seconds": "{{ seconds }}sek", "minutes": "{{ minutes }}min", "hours": "{{ hours }}tim", "days": "{{ days }}dagar", "hoursAndMinutes": "{{ hours }}tim {{ minutes }}min" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }} / {{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, anknytning {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "sv": "static-7.927"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.927",
    "ar-eg": "static-7.927",
    "bg": "static-7.927",
    "bn": "static-7.927",
    "ca-es": "static-7.927",
    "cs": "static-7.927",
    "da": "static-7.927",
    "de": "static-7.927",
    "el": "static-7.927",
    "en-gb": "static-7.927",
    "en": "static-7.927",
    "es-mx": "static-7.927",
    "es": "static-7.927",
    "fi": "static-7.927",
    "fr-ca": "static-7.927",
    "fr": "static-7.927",
    "he-il": "static-7.927",
    "hr": "static-7.927",
    "hu": "static-7.927",
    "id": "static-7.927",
    "it": "static-7.927",
    "ja": "static-7.927",
    "ko": "static-7.927",
    "lt": "static-7.927",
    "ms": "static-7.927",
    "nl": "static-7.927",
    "no": "static-7.927",
    "pl": "static-7.927",
    "pt-br": "static-7.927",
    "pt-pt": "static-7.927",
    "ro": "static-7.927",
    "ru": "static-7.927",
    "sk": "static-7.927",
    "sl": "static-7.927",
    "sv": "static-7.927",
    "th": "static-7.927",
    "tl": "static-7.927",
    "tr": "static-7.927",
    "uk": "static-7.927",
    "vi": "static-7.927",
    "x-pseudo": "static-7.927",
    "zh-cn": "static-7.927",
    "zh-hk": "static-7.927",
    "zh-tw": "static-7.927"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:sv', {version: 'static-7.927'}); }
})();


